<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.orderNo" label="外贸成品发车单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.companyName" label="贸易公司名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departName" label="冷库" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.teamName" label="包装管理组" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="包装管理组负责人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departDate" label="成品发车日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.varietyName" label="品种" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>
      <van-collapse-item title="成品装车信息" name="1">
        <van-field v-model="inputForm.weighFlagLabel" label="是否分开称重" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.truckWeight" label="装车总重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.truckWeightEmpty" label="空车过磅重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.varietyGrossWeight" label="含筐总重（斤）" :formatter="formatter" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.truckNum" label="装车总件数" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.varietyNetWeight" label="不含筐总重（斤）" :formatter="formatter" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
          <p style="display: block; color: #4caedc" @click="viewDetail()">查看明细</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="成品过磅信息" name="2" v-if="inputForm.weighFlag==='0'">
        <van-field v-model="inputForm.weighFee" label="过磅费" :formatter="formatter" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.weighFeeAttachList.length > 0">
          <p style="color: #AAA">过磅小票</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.weighFeeAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="成品发车信息" name="3">
        <van-field v-model="inputForm.departAddress" label="成品发车详细地址" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.truckDriverName" label="货车司机" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.truckDriverPhone" label="司机联系方式" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.plateNo" label="境内运输车牌号" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.departAttachList.length > 0">
          <p style="color: #AAA">车头照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.departAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.departBodyAttachList.length > 0">
          <p style="color: #AAA">车身照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.departBodyAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.departTailAttachList.length > 0">
          <p style="color: #AAA">车尾照片</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.departTailAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="成品出境口岸信息（对应外销）" name="4">
        <van-field v-model="inputForm.huanPortName" label="出境口岸" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.manageGroupContactsTeam" label="报关管理组" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.manageGroupContacts" label="报关组联系人" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.manageGroupContactsWay" label="报关小组联系方式" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="成品境外收货信息（对应外销）" name="5">
        <van-field v-model="inputForm.consignCorpName" label="境外收货公司" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.consignLinkPerson" label="境外收货联系人" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.consignLinkPhone" label="境外收货联系人联系方式" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.consignName" label="境外收货地点" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.consignAddress" label="境外详细地址" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "ItsOrderDepart",
  data() {
    return {
      activeNames: ['1','2','3','4','5'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        weighFeeAttachList: [],
        departAttachList: [],
        departBodyAttachList: [],
        departTailAttachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_order_depart'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/order/itsOrderDepart/queryById').then(({data}) => {
        this.inputForm = data
        this.inputForm.weighFlagLabel = this.inputForm.weighFlag === '1' ? '是' : '否'
        if(!data.weighFeeAttachIds) {
          this.inputForm.weighFeeAttachList = []
        }
        // this.getDict([
        //   ['its_base_variety', 'varietyId'],
        // ])
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value) {
      return Number(value).toFixed(2)
    },
    viewDetail(){
      this.$router.push({
        path: '/ItsOrderDepartDetail',
        query: {
          data: JSON.stringify(this.inputForm.detailList)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>